import { get } from 'lodash';

export const getSummary = state => get(state, 'MealSummaryState.summary');

export const getError = state => get(state, 'MealSummaryState.error');

export const getLoading = state => get(state, 'MealSummaryState.loading');

export const getAmount = state => get(state, 'MealSummaryState.amount');

export const getDayClosed = state => get(state, 'MealSummaryState.dayClosed');

export const getOpeningCashCalc = state =>
  get(state, 'MealSummaryState.openingCashCalc');

export const getOpeningChecks = state =>
  get(getOpeningCashCalc(state), 'checks', []);

export const getClosingChecks = state =>
  get(getClosingCashCalc(state), 'checks', []);

export const getClosingCashCalc = state =>
  get(state, 'MealSummaryState.closingCashCalc');

export const getUsers = state => get(state, 'MealSummaryState.users');

export const getSummaryRan = state => get(state, 'MealSummaryState.summaryRan');



// WEBPACK FOOTER //
// ./src/pages/mealsummary/state/selectors.js